/**
 * @generated SignedSource<<0ede954483208e949ad3ee6f2676819c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventState = "READY" | "WAITING" | "%future added value";
export type SeriesSortColumn = "CREATED" | "EVENT_COUNT" | "TITLE" | "UPDATED" | "%future added value";
export type SeriesState = "READY" | "WAITING" | "%future added value";
export type SortDirection = "ASCENDING" | "DESCENDING" | "%future added value";
export type Visibility = "PRIVATE" | "PUBLIC" | "SHARED" | "%future added value";
export type SeriesSortOrder = {
  column: SeriesSortColumn;
  direction: SortDirection;
};
export type SearchFilter = {
  createdEnd?: string | null | undefined;
  createdStart?: string | null | undefined;
  textQuery?: string | null | undefined;
  visibility?: Visibility | null | undefined;
};
export type SeriesManageQuery$variables = {
  filter?: SearchFilter | null | undefined;
  limit: number;
  offset: number;
  order: SeriesSortOrder;
};
export type SeriesManageQuery$data = {
  readonly currentUser: {
    readonly mySeries: {
      readonly __typename: "SeriesConnection";
      readonly items: ReadonlyArray<{
        readonly created: string | null | undefined;
        readonly creators: ReadonlyArray<string>;
        readonly description: string | null | undefined;
        readonly hasPublicVideos: boolean;
        readonly id: string;
        readonly numVideos: number;
        readonly state: SeriesState;
        readonly thumbnailStack: {
          readonly thumbnails: ReadonlyArray<{
            readonly audioOnly: boolean;
            readonly live: boolean;
            readonly state: EventState;
            readonly url: string | null | undefined;
          }>;
        };
        readonly title: string;
        readonly tobiraDeletionTimestamp: string | null | undefined;
        readonly updated: string | null | undefined;
      }>;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
        readonly hasPrevPage: boolean;
      };
      readonly totalCount: number;
    };
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"UserData">;
};
export type SeriesManageQuery = {
  response: SeriesManageQuery$data;
  variables: SeriesManageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "order"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "filter",
      "variableName": "filter"
    },
    {
      "kind": "Variable",
      "name": "limit",
      "variableName": "limit"
    },
    {
      "kind": "Variable",
      "name": "offset",
      "variableName": "offset"
    },
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    }
  ],
  "concreteType": "SeriesConnection",
  "kind": "LinkedField",
  "name": "mySeries",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasNextPage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasPrevPage",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Series",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "created",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updated",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tobiraDeletionTimestamp",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numVideos",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasPublicVideos",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "creators",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ThumbnailStack",
          "kind": "LinkedField",
          "name": "thumbnailStack",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ThumbnailInfo",
              "kind": "LinkedField",
              "name": "thumbnails",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "live",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "audioOnly",
                  "storageKey": null
                },
                (v4/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SeriesManageQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "UserData"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SeriesManageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userRealmHandle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canUpload",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canUseStudio",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canUseEditor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canCreateUserRealm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canCreateSeries",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canCreatePlaylists",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTobiraAdmin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAdmin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canFindUnlisted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roles",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userRole",
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3b0317f73295a2fd127b31c21fb728c7",
    "id": null,
    "metadata": {},
    "name": "SeriesManageQuery",
    "operationKind": "query",
    "text": "query SeriesManageQuery(\n  $order: SeriesSortOrder!\n  $offset: Int!\n  $limit: Int!\n  $filter: SearchFilter\n) {\n  ...UserData\n  currentUser {\n    mySeries(order: $order, offset: $offset, limit: $limit, filter: $filter) {\n      __typename\n      totalCount\n      pageInfo {\n        hasNextPage\n        hasPrevPage\n      }\n      items {\n        id\n        title\n        created\n        updated\n        tobiraDeletionTimestamp\n        description\n        state\n        numVideos\n        hasPublicVideos\n        creators\n        thumbnailStack {\n          thumbnails {\n            url\n            live\n            audioOnly\n            state\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment UserData on Query {\n  currentUser {\n    username\n    displayName\n    userRealmHandle\n    canUpload\n    canUseStudio\n    canUseEditor\n    canCreateUserRealm\n    canCreateSeries\n    canCreatePlaylists\n    isTobiraAdmin\n    isAdmin\n    canFindUnlisted\n    roles\n    userRole\n  }\n}\n"
  }
};
})();

(node as any).hash = "946eebec34822ed6d92b15503b87565e";

export default node;
